var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { stringify } from 'qs';
import { axiosInstance } from '@/api/realApi/_axios';
import { joinUrl } from '@/api/realApi/_utils';
import { getCsrfHeaders } from '@/api/realApi/authApi';
const CHARACTERS_URL_PATH = '/api/characters/';
const CHARACTER_LIST_PAGE_SIZE = 100;
export const characterApi = {
    list: (params) => __awaiter(void 0, void 0, void 0, function* () {
        const _a = params !== null && params !== void 0 ? params : {}, { page: requestPage, page_size: requestPageSize } = _a, rest = __rest(_a, ["page", "page_size"]);
        const page_size = requestPageSize !== null && requestPageSize !== void 0 ? requestPageSize : CHARACTER_LIST_PAGE_SIZE;
        const getPage = (page) => __awaiter(void 0, void 0, void 0, function* () {
            var _a;
            const response = yield axiosInstance.get(joinUrl([CHARACTERS_URL_PATH, '/character/']), {
                params: Object.assign(Object.assign({}, rest), { page, page_size }),
                paramsSerializer: (p) => stringify(p, { arrayFormat: 'comma' }),
            });
            const data = response.data;
            if (Array.isArray(data)) {
                return { items: data, hasNext: false };
            }
            return {
                items: (_a = data.results) !== null && _a !== void 0 ? _a : [],
                hasNext: Boolean(data.next),
            };
        });
        if (requestPage !== undefined) {
            const { items } = yield getPage(requestPage);
            return items;
        }
        const all = [];
        for (let page = 1;; page += 1) {
            const { items, hasNext } = yield getPage(page);
            all.push(...items);
            if (!hasNext || items.length === 0) {
                break;
            }
        }
        return all;
    }),
    create: (card) => __awaiter(void 0, void 0, void 0, function* () {
        const config = yield getCsrfHeaders();
        const res = yield axiosInstance.post(joinUrl([CHARACTERS_URL_PATH, '/character/']), card, config);
        return res.data;
    }),
    update: (card) => __awaiter(void 0, void 0, void 0, function* () {
        const config = yield getCsrfHeaders();
        const res = yield axiosInstance.patch(joinUrl([CHARACTERS_URL_PATH, '/character/', card.id]), card, config);
        return res.data;
    }),
    delete: (id) => __awaiter(void 0, void 0, void 0, function* () {
        const config = yield getCsrfHeaders();
        yield axiosInstance.delete(joinUrl([CHARACTERS_URL_PATH, '/character/', id]), config);
    }),
    updateSpellSlot: (characterId_1, slotId_1, action_1, ...args_1) => __awaiter(void 0, [characterId_1, slotId_1, action_1, ...args_1], void 0, function* (characterId, slotId, action, amount = 1) {
        const config = yield getCsrfHeaders();
        const url = joinUrl([CHARACTERS_URL_PATH, '/character/', characterId, 'update_spell_slot']);
        const res = yield axiosInstance.post(url, { spellSlots: slotId, action, amount }, config);
        return res.data;
    }),
    resetSpellSlots: (characterId) => __awaiter(void 0, void 0, void 0, function* () {
        const config = yield getCsrfHeaders();
        const url = joinUrl([CHARACTERS_URL_PATH, '/character/', characterId, 'reset_spell_slots']);
        const res = yield axiosInstance.post(url, {}, config);
        return res.data;
    }),
    longRest: () => __awaiter(void 0, void 0, void 0, function* () {
        const config = yield getCsrfHeaders();
        const url = joinUrl([CHARACTERS_URL_PATH, 'actions', 'long_rest']);
        const res = yield axiosInstance.post(url, {}, config);
        return res.data;
    }),
};
export const charactersGroupApi = {
    list: () => __awaiter(void 0, void 0, void 0, function* () {
        const res = yield axiosInstance.get(joinUrl([CHARACTERS_URL_PATH, '/groups/']));
        return res.data;
    }),
    create: (group) => __awaiter(void 0, void 0, void 0, function* () {
        const config = yield getCsrfHeaders();
        const res = yield axiosInstance.post(joinUrl([CHARACTERS_URL_PATH, '/groups/']), group, config);
        return res.data;
    }),
    update: (group) => __awaiter(void 0, void 0, void 0, function* () {
        const config = yield getCsrfHeaders();
        const res = yield axiosInstance.patch(joinUrl([CHARACTERS_URL_PATH, '/groups/', group.id]), group, config);
        return res.data;
    }),
    delete: (group) => __awaiter(void 0, void 0, void 0, function* () {
        const config = yield getCsrfHeaders();
        yield axiosInstance.delete(joinUrl([CHARACTERS_URL_PATH, '/groups/', group.id]), config);
    }),
    addCharacterToGroup: (group, character) => __awaiter(void 0, void 0, void 0, function* () {
        const config = yield getCsrfHeaders();
        yield axiosInstance.post(joinUrl([CHARACTERS_URL_PATH, '/groups/', group.id, '/add_character/']), { characters: [character.id] }, config);
    }),
    removeCharacterFromGroup: (group, character) => __awaiter(void 0, void 0, void 0, function* () {
        const config = yield getCsrfHeaders();
        yield axiosInstance.post(joinUrl([CHARACTERS_URL_PATH, '/groups/', group.id, '/remove_character/']), { characters: [character.id] }, config);
    }),
};
